import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import { BlManualPage } from "#/components/pages/bl-manual/bl-manual-page";

export const Route = createFileRoute("/$tenantCode/$market/bl-manual")({
  beforeLoad: () => ({ getTitle: () => m["resources.blManual.name"]() }),
  component: BlManualPage,
});
